module.exports = __webpack_public_path__ + "static/media/rgukt_logo.211094e0.webp";